import React, { ReactElement } from 'react'
import mapMarker from '../../../assets/images/fa/map-marker.svg'
import { HubboxCollectPoint as HubboxCollectPointType } from './types/models'

type HubboxCollectPointProps = {
  hubboxCollectPoint: HubboxCollectPointType
  launchHubbox: () => void
}

const HubboxCollectPoint = ({ hubboxCollectPoint: { name, address: { street1, city, postcode } }, launchHubbox }: HubboxCollectPointProps): ReactElement => {
  const capitalise = (s: string): string => s.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
  return (
  <div className="basket-collectPoint">
    <div>
      <img src={mapMarker} alt="" className="basket-collectPoint-icon" loading="lazy" width="18" height="18" />
    </div>
    <div>
      <h4 className='basket-collectPoint-heading'>{ name }</h4>
      <p className='basket-collectPoint-detail'>{capitalise(street1)}<br/>{capitalise(city)}, {postcode}</p>
      <p className='basket-collectPoint-edit' onClick={launchHubbox}>Change pickup point</p>
    </div>
  </div>
  )
}

export default HubboxCollectPoint
